import type React from 'react';

import { Button } from '@change/ds-core-ui';

import type { StarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import type { FullPostType, PostPreviewSizes, RetryState } from 'src/app/pages/starterDashboardV2/shared/components';
import { CTA_MAP, PostPreview } from 'src/app/pages/starterDashboardV2/shared/components';

type Props = {
	fullPostType: FullPostType;
	petition: StarterDashboardV2PageData['petition'];
	previewSize: PostPreviewSizes;
	retryState: RetryState;
	onRetry: () => void;
};

export const PostPreviewCardRetry: React.FC<Props> = (props) => {
	const { fullPostType, petition, previewSize, retryState, onRetry } = props;

	const isRetrying = retryState === 'retrying';
	const buttonText = isRetrying ? 'Retrying...' : CTA_MAP[fullPostType];

	// Empty sharing resource for skeleton display
	const emptySharingResource = {
		message: '',
		previewImageUrl: '',
		petitionTitle: '',
		shareUrl: '',
		recommendedGroup: { name: '', url: '', metadata: { memberCount: 0, imageUrl: '', source: '' } },
	};

	return (
		<section
			key={`${fullPostType}-retry`}
			className="flex gap-3"
			data-testid={`${fullPostType}-post-card-retry`}
			aria-label={`Retry ${fullPostType}`}
		>
			<div className="flex flex-col gap-3 gap-y-6">
				<PostPreview
					variant={fullPostType}
					sharingResource={emptySharingResource}
					size={previewSize}
					loading
					showPlatformIcon
					data-testid={`${fullPostType}-post-preview-retry`}
					petition={petition}
					disabled={isRetrying}
					retryState={isRetrying ? undefined : 'failed'}
					onRetry={onRetry}
				/>
				<Button
					variant="secondary"
					size="x-small"
					disabled
					data-qa={`${fullPostType}-retry-button`}
					data-testid={`${fullPostType}-retry-button`}
					aria-label={buttonText}
					className="w-full min-w-36 no-underline md:min-w-0"
				>
					{buttonText}
				</Button>
			</div>
		</section>
	);
};
